import { ComponentProps } from "react"

import { cn } from "~/lib/cn"

const baseClass =
  "w-70 rounded-lg transition-all duration-200 hover:bg-gray-100 hover:text-gray-500 focus:ring-3 focus:ring-blue-300 focus:dark:ring-blue-900 dark:hover:bg-true-gray-900 dark:hover:text-gray-200 dark:text-white text-center"
TextButton.baseClass = baseClass

export function TextButton({ className, ...props }: ComponentProps<"button">) {
  return <button {...props} className={cn(baseClass, className ?? "")}></button>
}
